<template>
  <div style="width: 100%" class="fill-height">
    <v-row class="pt-3 pr-3">
      <v-spacer></v-spacer>
      <Search-box
        :emitDestination="searchEmitDestination"
        searchPlaceholder="Pretraži artikle"
      ></Search-box
    ></v-row>

    <v-container class="pt-0">
      <v-row
        v-if="listView"
        style="margin-top: 0px"
        class="d-flex justify-center"
      >
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <div class="staff-rows-body">
            <v-card v-for="(staff, i) in staffs" :key="i"
              :class="['staff-card', getStatusClass(staff)]">
              <v-row class="ma-0 align-center" style="min-height: 60px;">
                <v-col style="min-width: 0; flex-grow: 1; max-width: none; padding: 8px 16px;">
                  <div class="staff-name one-liner-text">
                    {{ $options.filters.capitalize(staff.name) }} {{ $options.filters.capitalize(staff.surname) }}
                  </div>
                </v-col>
                <v-col style="min-width: 0; flex-grow: 1; max-width: none; padding: 8px 16px;">
                  <div class="staff-cell one-liner-text">{{ showStaffCategories(staff.categories) }}</div>
                </v-col>
                <v-col cols="auto" style="padding: 8px 16px;">
                  <v-chip x-small :class="getStatusChipClass(staff)">{{ staff.status }}</v-chip>
                </v-col>
                <v-col cols="auto" style="padding: 8px 8px;">
                  <v-btn icon small
                    :disabled="staff.status !== 'OK'"
                    @click="openEditStaff(staff)"
                    @keypress.enter="openEditStaff(staff)">
                    <v-icon color="#3989C9">mdi-pencil-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-col>
        <add-staff ref="addStaff" @refreshStaff="refresh()"></add-staff>
        <edit-staff ref="editStaff" @refreshStaff="refresh()"></edit-staff>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more" class="text--secondary font-italic"></div>
        <div slot="no-results" class="text--secondary font-italic"></div>
      </infinite-loading>
    </v-container>
  </div>
</template>
<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
import InfiniteLoading from 'vue-infinite-loading'
import EventBus from '@/plugins/event-bus'
import { collection, query, orderBy, getDocs, where, limit, startAfter } from 'firebase/firestore'
import AddStaff from '@/modules/point-of-sale/components/workorder/AddStaff'
import EditStaff from '@/modules/point-of-sale/components/workorder/EditStaff'

export default {
  name: 'Staffs',
  inject: ['showLoader', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { InfiniteLoading, AddStaff, EditStaff },
  data: () => ({
    dialog: false,
    loading: false,
    totalArticles: 0,
    lastiItem: false,
    staffs: [],
    listeners: [],
    multiplier: 0,

    choosenText: '',
    innerSearch: undefined,
    barcode: [],
    searchEmitDestination: 'companyStaffSearch',
    lastDocSnapshot: null
  }),
  computed: {
    listView () {
      return state.isListView()
    },
    search () {
      return state.search
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    }
  },
  async mounted () {
    document.onkeydown = this.handleKeyEvents

    EventBus.$on(this.searchEmitDestination, (searchObject) => {
      if (!searchObject.triGramObject) {
        this.lastDocSnapshot = null
        this.detachListeners()
        this.resetHandler()
      } else {
        this.getStaffNew(searchObject.triGramObject)
      }
    })
  },
  methods: {
    refresh () {
      this.lastDocSnapshot = null
      this.detachListeners()
      this.resetHandler()
    },
    openEditStaff (staff) {
      this.$refs.editStaff.open(staff)
    },
    openAddStaff () {
      this.$refs.addStaff.open()
    },
    showStaffCategories (categories) {
      var cat = ''
      if (categories && categories.length > 0) {
        categories.forEach((category, key) => {
          cat += category

          if (key + 1 < categories.length) {
            cat += ', '
          }
        })
      }

      return cat
    },
    resetHandler () {
      this.staffs = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    },
    async infiniteHandler ($state) {
      const newItemsCount = await this.getStaffNew()
      if (newItemsCount > 0) {
        return $state.loaded() // getStaffNew je vratio vise od nula artikala, znaci da ih ima jos
      }
      return $state.complete() // getStaffNew je vratio 0 artikala, znaci da ih vise nema
    },
    async getStaffNew (triGramObject = undefined) {
      const searchConstraints = []
      if (triGramObject) {
        Object.keys(triGramObject).forEach(name =>
          searchConstraints.push(where(`meta.${name}`, '==', true))
        )
      }

      if (!triGramObject) {
        searchConstraints.push(orderBy('name', 'asc'))
      }

      if (this.lastDocSnapshot && !triGramObject) {
        searchConstraints.push(startAfter(this.lastDocSnapshot))
      }

      searchConstraints.push(limit(10))

      const constraints = [
        collection(df, `workorder_staff/${state.getCurrentCompany().id}/staff`),
        ...searchConstraints
      ]

      const q = query.apply(this, constraints)

      const querySnapshot = await getDocs(q)
      this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1]

      const results = []
      querySnapshot.forEach(doc => {
        var staffIt = doc.data()

        results.push({ _id: staffIt.id, ...staffIt })
      })

      if (triGramObject) {
        this.staffs = results
        return true
      }

      this.staffs.push(...results)

      return results.length
    },

    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].clientHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },

    getStatusClass (staff) {
      if (staff.status === 'OK') return 'staff-status-ok'
      if (staff.status === 'PROCESSING') return 'staff-status-warn'
      return 'staff-status-failed'
    },
    getStatusChipClass (staff) {
      if (staff.status === 'OK') return 'staff-chip-ok'
      if (staff.status === 'PROCESSING') return 'staff-chip-warn'
      return 'staff-chip-failed'
    },
    openDialog () {
      this.dialog = true
    }

  }
}
</script>
<style scoped>
.staff-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.staff-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  margin-bottom: 4px !important;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.staff-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.staff-card.staff-status-ok     { border-left-color: #4ADE80 !important; }
.staff-card.staff-status-warn   { border-left-color: #FBBF24 !important; }
.staff-card.staff-status-failed { border-left-color: #F87171 !important; }

.staff-name {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}

.staff-cell {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}

.staff-chip-ok     { background-color: #DCFCE7 !important; color: #166534 !important; }
.staff-chip-warn   { background-color: #FEF9C3 !important; color: #854D0E !important; }
.staff-chip-failed { background-color: #FEE2E2 !important; color: #991B1B !important; }
</style>
